import React, { useState, useEffect } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isBoolean } from 'lodash-es';

import CollapsibleSlot from '../../CollapsibleSlot';

const AccordionSubMenu = ({
  open = false,
  label,
  children,
  className,
}) => {
  const [isOpen, setOpen] = useState(open);

  // Adds the ability to control isOpen from outside
  useEffect(() => {
    if (isBoolean(open)) setOpen(open);
  }, [open]);

  return (
    <div className={cx('accordion-submenu', { 'accordion-submenu--open': isOpen }, className)}>
      <div role="menuitem" className="accordion-submenu__header">
        {label}
        <div className="accordion-submenu__toggle-btn" onClick={() => setOpen(!isOpen)}>
          <span className="hicon-angle-down-alt" />
        </div>
      </div>
      <CollapsibleSlot show={isOpen} className="accordion-submenu__body">
        {children}
      </CollapsibleSlot>

    </div>
  );
};

AccordionSubMenu.propTypes = {
  open: T.bool,
  label: T.node.isRequired,
  children: T.node.isRequired,
  className: T.string,
};

export default AccordionSubMenu;
